

























































import { Component, Vue } from "vue-property-decorator";
import { LAPORAN_BANK_DARAH_CARDS } from "@/config/sidebar-menu";

@Component
export default class LaporanBankDarahMenuPage extends Vue {
  readonly cards = LAPORAN_BANK_DARAH_CARDS;

  goto(route: string | null) {
    if (!route) return;
    this.$router.push({ name: route });
  }
}
